// extracted by mini-css-extract-plugin
module.exports = {"downloadCtas":"ConfirmStaffAccountExists_downloadCtas__2PZm7","loginCta":"ConfirmStaffAccountExists_loginCta__3vawP"};